<div class="pt-page">

  <!-- Header -->
  <header class="pt-page__header">
    <div class="pt-page__header-left">
      <div class="pt-page__icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="2" y="7" width="20" height="14" rx="2"/>
          <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/>
          <line x1="12" y1="12" x2="12" y2="16"/>
          <line x1="10" y1="14" x2="14" y2="14"/>
        </svg>
      </div>
      <div>
        <h1 class="pt-page__title">Postes</h1>
        <p class="pt-page__desc">Gérez les postes de votre application.</p>
      </div>
    </div>
    <app-ui-button
      label="Ajouter un poste"
      variant="primary"
      size="md"
      iconLeft="add_circle_outline"
      type="button"
      (clicked)="openAddEntityModal()"
    ></app-ui-button>
  </header>

  <!-- Card / Table -->
  <div class="pt-card">
    @if (isLoading) {
      <div class="pt-loader-wrapper">
        <app-loaderIntervantion [isLoading]="isLoading" [rows]="6"></app-loaderIntervantion>
      </div>
    } @else {
      <div class="pt-card__toolbar">
        <div class="pt-card__toolbar-left">
          <span class="pt-badge">{{ entities.length }}</span>
          <span class="pt-card__count">
            poste{{ entities.length > 1 ? 's' : '' }} enregistré{{ entities.length > 1 ? 's' : '' }}
          </span>
        </div>
      </div>

      @if (!entities.length) {
        <div class="pt-empty">
          <div class="pt-empty__icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <rect x="2" y="7" width="20" height="14" rx="2"/>
              <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/>
            </svg>
          </div>
          <p class="pt-empty__title">Aucun poste</p>
          <p class="pt-empty__hint">Commencez par en ajouter un en cliquant sur le bouton ci-dessus.</p>
        </div>
      } @else {
        <app-ui-table [columns]="tableEntity" [data]="entities" [actions]="rowActions"/>
      }
    }
  </div>

  <!-- Row actions template -->
  <ng-template #rowActions let-item="item">
    <div class="pt-row-actions">
      <app-ui-button
        iconOnly="edit"
        variant="ghost"
        size="sm"
        ariaLabel="Modifier"
        type="button"
        (clicked)="onEditEntity(item)"
      ></app-ui-button>
      <app-ui-button
        iconOnly="delete"
        variant="danger"
        size="sm"
        ariaLabel="Supprimer"
        type="button"
        (clicked)="openDeleteConfirm(item)"
      ></app-ui-button>
    </div>
  </ng-template>

</div>

<!-- Confirm Dialog -->
<app-confirm-dialog
  [isVisible]="showDeleteConfirm"
  [itemLabel]="selectedItem?.libelle || ''"
  [isLoading]="deleteLoading"
  (confirmed)="confirmDelete()"
  (cancelled)="cancelDelete()"
></app-confirm-dialog>

<!-- Modal Ajout / Édition -->
<app-modal
  [isVisible]="showAddEntityModal"
  [title]="isEditing ? 'Modifier le poste' : 'Nouveau poste'"
  (closeEvent)="closeAddEntityModal()"
>
  <form [formGroup]="entityForm" (ngSubmit)="saveEntity()" class="pt-form">

    @if (isEditing && editingEntity) {
      <div class="pt-edit-banner">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
          <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
        Modification de <strong>{{ editingEntity.libelle }}</strong>
      </div>
    }

    <div class="pt-form__field">
      <app-input
        label="Libellé du poste"
        placeholder="Ex : Directeur financier"
        type="text"
        formControlName="libelle"
      />
      @if (entityForm.get('libelle')?.invalid && (entityForm.get('libelle')?.dirty || entityForm.get('libelle')?.touched)) {
        <span class="pt-form__error">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          Le libellé est requis.
        </span>
      }
    </div>

    <div class="pt-form__actions">
      <app-ui-button
        label="Annuler"
        variant="ghost"
        size="md"
        type="button"
        (clicked)="closeAddEntityModal()"
      ></app-ui-button>
      <app-ui-button
        [label]="isEditing ? 'Mettre à jour' : 'Enregistrer'"
        variant="primary"
        size="md"
        [iconLeft]="isEditing ? 'check' : 'save'"
        type="submit"
        [loading]="isLoading"
        [disabled]="isLoading || entityForm.invalid"
      ></app-ui-button>
    </div>

  </form>
</app-modal>